<app-navigation-layout [hideHeader]="false" [hideMenu]="true" [hideNavigation]="true" [hideMain]="true">

  <span header-container>
    <h2>{{ 'Payment cancelled. Redirecting to payment page.' | translate }}</h2>
  </span>

</app-navigation-layout>
